import { Dimensions, Platform, StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const TABLET_GALLERY_HEIGHT = Platform.select({
    web: Math.ceil(heightPercentageToDP(620)),
    default: Math.ceil(heightPercentageToDP(540)),
});
export const PHONE_GALLERY_HEIGHT = 420;
export const BROWSER_GALLERY_HEIGHT = Math.ceil(heightPercentageToDP(440));
export const BROWSER_GALLERY_WIDTH = Dimensions.get('window').width;

const styles = StyleSheet.create({
    container: {
        height: 'auto',
    },
    paginationBoxStyle: {
        position: 'absolute',
        bottom: 0,
        padding: 0,
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        paddingVertical: 10,
    },
    dotStyle: {
        width: 10,
        height: 10,
        borderRadius: 5,
        marginHorizontal: 0,
        padding: 0,
        margin: 0,
        backgroundColor: 'rgba(128, 128, 128, 0.92)',
    },
    image: {
        width: '100%',
        alignSelf: 'center',
    },
    imageContainer: {
        position: 'relative',
        justifyContent: 'center',
    },
    galleryPlaceholder: {
        height: Platform.select({
            web: Math.ceil(heightPercentageToDP(440)),
            default: isTablet ? heightPercentageToDP(450) : 450,
        }),
    },
    absolutePosition: {
        position: 'absolute',
    },
    paginationDot: {
        alignSelf: 'center',
    },

    gradientTablet: {
        position: 'absolute',
        top: 0,
    },
    gradientBottomTablet: {
        position: 'absolute',
        bottom: 0,
    },
    loadingActivity: {
        position: 'absolute',
        alignSelf: 'center',
    },
    playerButton: {
        alignSelf: 'center',
        top: '35%',
        position: 'absolute',
    },
    paginationDotContainer: isTabletOrWeb
        ? {
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
              marginTop: 12,
              marginRight: 44,
          }
        : {
              alignSelf: 'center',
          },
    subtractContainer: {
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'space-evenly',
        flexDirection: 'row',
        height: 20,
        width: 38,
        backgroundColor: 'red',
    },
    phoneDotsContainer: { position: 'absolute', top: 444 },
    webDotsContainer: {
        position: 'absolute',
        marginRight: 0,
        right: widthPercentageToDP(72),
        bottom: 0,
        zIndex: 100000,
    },
    bwdButton: {
        transform: [{ rotate: '180deg' }],
    },
    webPaginationContainer: {
        backgroundColor: blackTransparent(0.5),
        height: 36,
        alignItems: 'center',
        borderRadius: 36,
    },
    webSkeletonContainer: {
        width: BROWSER_GALLERY_WIDTH,
        height: BROWSER_GALLERY_HEIGHT,
    },
});

export default styles;
